import { useSelector } from 'react-redux';
import type { RootState } from '../../../store';
import BaseSearchPage from './BaseSearchPage';
import { getSearchPageContent } from './searchPageConfig';

const SearchPage = () => {
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  return <BaseSearchPage content={getSearchPageContent(selectedTenancy)} />;
};

export { SearchPage };
